module.exports = __webpack_public_path__ + "static/media/restore-confirm.a94bb20c.png";